export default __webpack_public_path__ + "static/logo-opt-d507a97b8dc16dc3aa8bec13390099ae.svg";